import styled from '@emotion/styled';
import { EFontFamily } from 'helpers/constants';
import { primary } from 'helpers/colors';
import { rem } from 'helpers/utils';

export const Cart = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',

  '.cancel-btn': {
    position: 'absolute',
    top: 18,
    right: 8,
    width: 20,
    height: 20,
    padding: 0,
    backgroundColor: primary.main,
    color: primary.contrast,
    zIndex: 1,
    transition: 'background-color 0.2s ease, transform 0.15s ease',

    '&:hover': {
      backgroundColor: primary.dark,
      transform: 'scale(1.15)'
    },

    '& svg': {
      fontSize: 14
    }
  },

  '.cart': {
    border: `1px solid #E7E7E9`,
    borderRadius: 10,
    padding: 10,
    paddingRight: 32,
    margin: `${rem(10)} 0`,
    width: '100%',
    flex: 1,
    boxSizing: 'border-box',
    cursor: 'pointer',
    transition: 'border-color 0.2s ease, background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'left',
    gap: 12,

    '& p': {
      padding: 0,
      margin: 0,
      fontFamily: EFontFamily.poppins
    },

    '.card-icon': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      color: '#e3e3e3',
      marginRight: 10,
      marginLeft: 8,

      '& svg': {
        fontSize: 36,

        '@media (max-width: 1280px)': {
          fontSize: 28
        }
      }
    },

    '.card-content': {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minWidth: 0
    },

    '.label': {
      fontSize: 14,
      color: '#737171',
      fontWeight: 500,

      '@media (max-width: 1280px)': {
        fontSize: 12
      }
    },

    '.value': {
      fontSize: 28,
      color: '#4A4A4A',
      fontWeight: 400,

      '@media (max-width: 1280px)': {
        fontSize: 22
      }
    },

    '.value-loading': {
      marginTop: 4
    },

    '&:hover:not(.selected)': {
      transform: 'translateY(-2px)',
      boxShadow: `0 4px 12px rgba(0, 0, 0, 0.04)`
    },

    '&.selected': {
      border: `1px solid ${primary.main}`,
      backgroundColor: primary.lighter,
      transform: 'translateY(-2px)',
      boxShadow: `0 4px 12px rgba(66, 33, 156, 0.05)`,

      '.label, .card-icon': {
        color: primary.main
      },

      '.value p': {
        color: primary.main,
        fontWeight: 600
      }
    }
  }
}));
